export default {
  ExchangeRates: {
    OVERRIDE: 'Override the exchange rate for your postings',
    OVERRIDDEN: 'Exchange rate has been manually overridden',
    Modal: {
      HEADING: 'Override Currency Exchange Rate',
      BODY_RECHARGER: 'This will override the exchange rate between {{from}} and {{to}} on the given date or range. This rate will be used for Recharger only.',
      BODY_BALANCER: 'This will override the exchange rate between {{from}} and {{to}} on the given date or range. This rate will be used for Balancer only.',
      RANGE: 'This rate is',
      Ranges: {
        DAY: 'Daily for {{date}}',
        MONTH: 'For the whole of {{month}}',
        MONTH_SUB: 'This will be used if there is no day rate set',
        ALL: 'Fixed for all time',
        ALL_SUB: 'This will be used if there is no month or day rate set',
      },
    },
  },
};
